import { render, staticRenderFns } from "./MyShoppingTable.vue?vue&type=template&id=f612dba4&scoped=true"
import script from "./MyShoppingTable.vue?vue&type=script&lang=js"
export * from "./MyShoppingTable.vue?vue&type=script&lang=js"
import style0 from "./MyShoppingTable.vue?vue&type=style&index=0&id=f612dba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612dba4",
  null
  
)

export default component.exports